/* eslint-disable */

export const ValidateUtils = {

    validateNotEmpty(item, properties, errors) {
        if (item == null) return false;
        errors = errors || [];
        let notEmpty = true;
        properties.forEach((prop) => {
            if (item[prop] == null || item[prop] === "") {
                notEmpty = false;
                errors[prop] = "This field is required";
            }
        });
        return notEmpty;
    },

};
